// extracted by mini-css-extract-plugin
export var styles = "button-module--styles--eb352";